export enum UserRoleType {
    USER_VIEW_ONLY = 1,
    USER_ENTER_EDIT = 2,
    USER_ENTER_EDIT_SUBMIT = 3,
    STAFF_ADMIN = 4,
    SITE_ADMIN = 5,
}
